import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

import type { ForgeUIAnalyticsContext } from '@atlassian/xen-editor-provider';
import { ProductEnvironment } from '@atlassian/xen-editor-provider';

import { cfetch } from '@confluence/network';

let forgeClient: ApolloClient<any> | undefined;
export const getForgeClient = () => {
	if (forgeClient) {
		return forgeClient;
	} else {
		forgeClient = new ApolloClient({
			connectToDevTools: process.env.NODE_ENV !== 'production',
			link: new HttpLink({
				credentials: 'include',
				uri: '/gateway/api/graphql',
				fetch: cfetch,
			}),
			cache: new InMemoryCache(),
		});
		return forgeClient;
	}
};

export const createForgeMacroExtensionData = ({
	contentId,
	spaceKey,
	spaceId,
}: {
	contentId: string;
	spaceKey: string;
	spaceId?: string;
}) => ({
	type: 'macro',
	content: {
		id: contentId,
	},
	space: {
		key: spaceKey,
		id: spaceId,
	},
});

export function createForgeUIAnalyticsContext({
	objectId,
	objectType,
	containerId,
	containerType,
}: {
	objectId: string;
	objectType: 'page' | 'blogpost' | null;
	containerId: string | null;
	containerType: 'space';
}): ForgeUIAnalyticsContext {
	return {
		objectId,
		objectType: objectType || undefined,
		containerId: containerId || undefined,
		containerType,
	};
}

export function environmentToForgeProductEnvironment(environment: string) {
	return (
		// In dev, proxying to a site will give that site's environment,
		// which is not what we want
		window.location.hostname === 'localhost'
			? ProductEnvironment.DEVELOPMENT
			: environment === 'STAGING'
				? ProductEnvironment.STAGING
				: environment === 'PRODUCTION'
					? ProductEnvironment.PRODUCTION
					: ProductEnvironment.DEVELOPMENT
	);
}
